import { render } from "./CreateServiceCategory.vue?vue&type=template&id=0ae4a48a"
import script from "./CreateServiceCategory.vue?vue&type=script&lang=js"
export * from "./CreateServiceCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__